import {get, put} from '@/api/request.js'

const url = '/admin/testing/instruments'
/**
 * 获取未配置的检验平台
 * @returns {Promise<void>}
 */
export const get_testing_instruments = async function (page, page_size) {
    return await get(url, {
        params: {page, page_size}
    })
}


/**
 * 修改未配置的检验平台
 * @param {Array}ids id列表
 * @param {string}platform 检验平台
 * @returns {Promise<AxiosResponse<any>>}
 */
export const edit_testing_instruments = async function (ids, platform) {
    return await put(url, {
        data: {
            ids, platform
        }
    })
}
